import { render, staticRenderFns } from "./regModal.vue?vue&type=template&id=225c0e00&scoped=true"
import script from "./regModal.vue?vue&type=script&lang=js"
export * from "./regModal.vue?vue&type=script&lang=js"
import style0 from "./regModal.vue?vue&type=style&index=0&id=225c0e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c0e00",
  null
  
)

export default component.exports